export default {
  install(Vue, { store }) {
    Vue.http.interceptors.push((request, next) => {
      next(response => {
        if (response.body && response.body && response.body.error && (response.body.disconnectDirect || response.body.error === 'dash.error.conciergerie.token')) {
          console.log('HTTP Response Interceptor:', response)
          store.dispatch('selectPage/fetchAllPages');
        }
      })
    })
  }
}